import TwitterText from 'twitter-text';

export type CharacterCountValidationType = 'normal' | 'twitter';

export class CharacterCountResult {
  valid: boolean;
  length: number;
  remaining: number;
  isOverLimit: boolean;

  public static forText(text: string, maxCount: number): CharacterCountResult {
    if (!text) {
      return CharacterCountResult.forEmptyMessage(maxCount);
    }
    const length = text.length;
    const valid = length <= maxCount;
    return <CharacterCountResult>{
      valid,
      isOverLimit: !valid,
      length: length,
      remaining: maxCount - length
    };
  }

  public static forTwitter(text: string, maxCount: number): CharacterCountResult {
    if(!text) {
      return CharacterCountResult.forEmptyMessage(maxCount);
    }
    const result = TwitterText.parseTweet(text);
    return <CharacterCountResult>{
      valid: result.valid,
      isOverLimit: !result.valid,
      length: result.weightedLength,
      remaining: maxCount - result.weightedLength
    };
  }

  private static forEmptyMessage(maxCount: number): CharacterCountResult {
    return <CharacterCountResult>{
      valid: true,
      isOverLimit: false,
      length: 0,
      remaining: maxCount
    };
  }
}

export class CharacterCountValidator {
  static validate(text: string, maxCount: number, validationType: CharacterCountValidationType): CharacterCountResult {
    if (validationType === 'twitter') {
      // Use Twitter's character counting logic
      return CharacterCountResult.forTwitter(text, maxCount);
    } else {
      // Default character counting logic
      return CharacterCountResult.forText(text, maxCount);
    }
  }

  static isValid(text: string, maxCount: number, validationType: CharacterCountValidationType): boolean {
    const result = this.validate(text, maxCount, validationType);
    return result.valid;
  }

  static isOverLimit(text: string, maxCount: number, validationType: CharacterCountValidationType): boolean {
    return !this.isValid(text, maxCount, validationType);
  }

  static getMessageLength(text: string, maxCount: number, validationType: CharacterCountValidationType): number {
    const result = this.validate(text, maxCount, validationType);
    return result.length;
  }
}